import React from 'react'
import FeedList from '../components/FeedList'
import PlayerList from '../data/PlayerList'  // don't think this should be here ...
import ActivityList from '../data/ActivityList'
import ScrollToTop from '../components/ScrollToTop'

const ViewPlayer = (props) => {
  const playerId = Number(props.match.params.id);  // comes as a String
  const playerInfo = PlayerList[playerId];
  const activityList = ActivityList.getActivityForPlayer(playerId);
  //console.log(JSON.stringify(activityList));

  const list = activityList.map((event, index) => {
    // add 'playerName' to the scores info, and do a deep copy
    let newevent = JSON.parse(JSON.stringify(event));
    newevent.scores.forEach( (score) => {
      score.playerName = PlayerList[score.playerId].name;
    });
    //console.log('NEWEVENT: ' + JSON.stringify(newevent));
    return newevent;
  });

  let image = "";
  if (playerInfo.image) {
    image = <img className="playerimage" src={'/' + playerInfo.image} alt={playerInfo.name} />;
  }

  return (
    <ScrollToTop>
      <div>
      <h1>{playerInfo.name}'s Activity Feed</h1>
      <div className="div_playerimage">{image}</div>
      <FeedList activityList={list}/>
    </div>
    </ScrollToTop>
  );
};

export default ViewPlayer;



// WEBPACK FOOTER //
// ./src/containers/ViewPlayer.js